require('./login.controller')
require('./signup.controller')
require('./forgotPassword.controller')
require('./resetpassword.controller')
require('./logout.controller')
require('./profileDropdown.controller')
require('./organizationManage.controller')
require('./organizationManage')
require('./change.password.controller')
require('./change.organization.controller')
require('./language.change.controller')
require('./edge') // this includes all controllers related to edge
require('./edgeGroup')
require('./partner')
require('./home.controller')
require('./settings.controller')
require('./showLanguages.controller')
require('./version.controller')
require('./dashcamLiveVideo.controller')
require('./dashcamLiveVideo.deprecated.controller')
require('./recordingVideo.controller')
require('./recordingTimeline.controller.deprecated')
require('./recordingVideo.controller.deprecated')
require('./recordingTimeline.controller')
require('./recordingTimelineDownload.controller')
require('./device-ui-settings-edit.controller')
require('./bulk-device-ui-settings-edit.controller')
require('./surf-mp4-player.controller')
require('./surf-mp4-player-with-accelerometer.controller')
require('./surf-snapshot.controller')
require('./organization-device-settings-edit.controller')
require('./organization-events-settings-edit.controller')
require('./organization-webhooks-settings-edit.controller')
require('./organization-retention-settings-edit.controller')
require('./notification.controller')
require('./edge.DownloadRecordingVideo.Modal.controller')
require('./organization-data-profile-settings-edit-controller')
require('./privacy-mode-settings-edit.controller')
require('./organization-default-privacy-settings-edit.controller')
require('./familiarDriver.controller')
